import React from 'react';
import Step1 from "../../../../Assets/Images/Step1.png";
import Step2 from "../../../../Assets/Images/Step2.png";
import Step3 from "../../../../Assets/Images/Step3.png";
import Step4 from "../../../../Assets/Images/Step4.png";
import Step5 from "../../../../Assets/Images/Step5.png";
import Step6 from "../../../../Assets/Images/Step6.png";
import Step7 from "../../../../Assets/Images/Step7.png";
import Step8 from "../../../../Assets/Images/Step8.png";
import Step9 from "../../../../Assets/Images/Step9.png";
import Step10 from "../../../../Assets/Images/Step10.png";
import Step11 from "../../../../Assets/Images/Step11.png";
import Step12 from "../../../../Assets/Images/Step12.png";
import L from "../../../../Assets/Images/Lithenium.png";
import btc from "../../../../Assets/Images/btc.png";

export default function MobileTimeLine() {
  return (
    <div className="mobile-view d-block d-lg-none">
      <section className="about-timeline">
        <div className="wrapper inner-wrapper-padding">
          <div className="start-point">
            <div className="black-dot"></div>
            <h4>How It Works</h4>
            <div className="corner bl"></div>
          </div>

          <div className="timeline-main">
            <div className="timeline-row">
              <div className="timeline-box timeline-content-img logo-timeline-arrow">
                <div className="timeline-box-wrap">
                  <h6 className="circlecount">1</h6>
                  <div className="timeline-content">
                    <img src={Step1} alt="" />
                    <div className="timeline-content-txt">
                      <p>The first step after downloading the VPN app</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="timeline-box timeline-content-img logo-timeline-arrow">
                <div className="timeline-box-wrap">
                  <h5 className="circlecount">2</h5>
                  <div className="timeline-content">
                    <div className="timeline-content-txt">
                      <p>
                        In the first box, choose a name for yourself. In the
                        second box, enter your email address. In the third
                        box, enter the password you have chosen for
                        yourself. In the fourth box, confirm your password.
                        Click on the option at the bottom (Sign up) to
                        confirm your registration.
                      </p>
                    </div>
                    <img src={Step2} alt="" />
                  </div>
                </div>
              </div>
              <div className="horizontal-line"></div>
              <div className="verticle-line"></div>
              <div className="corner top"></div>
              <div className="corner bottom"></div>
            </div>

            <div className="timeline-row">
              <div className="timeline-box img-right timeline-content-img">
                <div className="timeline-box-wrap">
                  <h5 className="circlecount">3</h5>
                  <div className="timeline-content">
                    <div className="timeline-content-txt">
                      <p>
                        You will be automatically directed to the payment
                        page. Choose your desired package. By clicking on +
                        or - select the amount of data you want. Click on
                        Select Plan to confirm.
                      </p>
                    </div>
                    <img src={Step3} alt="" />
                  </div>
                </div>
              </div>
              <div className="timeline-box">
                <div className="timeline-box-wrap">
                  <h5 className="circlecount">4</h5>
                  <div className="timeline-content">
                    <div className="timeline-content-txt">
                      <p>
                        You will be automatically directed to the payment
                        method selection page. If you want to pay with
                        cryptocurrency, select Crypto as your payment
                        option.
                      </p>
                      <img src={Step4} alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="timeline-box img-right timeline-content-img top-timeline-arrow">
                <div className="timeline-box-wrap">
                  <h5 className="circlecount">5</h5>
                  <div className="timeline-content">
                    <div className="timeline-content-txt">
                      <div className="timeline-content">
                        <span className="title lh-sm">
                          Two cryptocurrencies have been preselected for
                          payment:{" "}
                        </span>
                        <div className="d-flex py-4 pb-0">
                          <div className="d-flex align-items-center">
                            <img src={L} alt="d" className="img-fluid" />
                            {/* <span className="ps-2">LTC –Litecoin</span> */}
                          </div>
                          <div className="d-flex align-items-center ps-4">
                            <img src={btc} alt="d" className="img-fluid" />
                            {/* <span className="ps-2">BCH -Bitcoin Cash</span> */}
                          </div>
                        </div>
                        <p className="fw-medium pt-3 d-block">
                          - These two cryptocurrencies have no transaction
                          fees. <br />- After selecting the cryptocurrency,
                          click on Submit.
                        </p>
                      </div>
                    </div>
                    <img src={Step5} className="mt-3" alt="" />
                  </div>
                </div>
              </div>
              <div className="horizontal-line"></div>
              <div className="verticle-line"></div>
              <div className="corner top"></div>
              <div className="corner bottom"></div>
            </div>
            <div className="timeline-row">
              <div className="timeline-box img-left timeline-content-img">
                <div className="timeline-box-wrap d-none">
                  <h5 className="circlecount">5</h5>
                  <div className="timeline-content">
                    <div className="timeline-content-txt">
                      <p>
                        Lorem Ipsum is simply dummy text of the printing
                        and.
                      </p>
                      <p>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry.
                      </p>
                    </div>
                    <img src={Step6} alt="" />
                  </div>
                </div>
              </div>
              <div className="timeline-box timeline-content-img">
                <div className="timeline-box-wrap">
                  <h5 className="circlecount">6</h5>
                  <div className="timeline-content">
                    <div className="timeline-content-txt">
                      <p>
                        After the QR code appears, click on this icon to
                        save it to your gallery.
                      </p>
                    </div>
                    <img src={Step6} alt="" />
                  </div>
                </div>
              </div>
              <div className="timeline-box">
                <div className="timeline-box-wrap">
                  <h5 className="circlecount">7</h5>
                  <div className="timeline-content">
                    <div className="timeline-content-txt">
                      <span className="title fw-bold lh-sm mb-2 d-block">
                        To make the payment, open your digital wallet. <br />
                        <span className="fs-6 fw-normal mt-3">
                          - Open the cryptocurrency that you selected in
                          step 6 and click on Send. <br />- For example, BCH
                          has been selected as the cryptocurrency here.
                        </span>
                      </span>
                    </div>
                    <img src={Step7} alt="" className="mt-2" />
                  </div>
                </div>
              </div>
              <div className="horizontal-line"></div>
              <div className="verticle-line"></div>
              <div className="corner top"></div>
              <div className="corner bottom"></div>
            </div>
            <div className="timeline-row">
              <div className="timeline-box d-none">
                <div className="timeline-box-wrap">
                  <h5 className="circlecount">8</h5>
                  <div className="timeline-content">
                    <div className="timeline-content-txt">
                      To find QR code in your gallery, click on this icon
                      with the red underline to select the code. The amount
                      to be paid is saved, and it will be shown to you
                      before confirming the payment with the QR code.
                    </div>
                    <img src={Step8} alt="" className="mt-2" />
                  </div>
                </div>
              </div>
              <div className="timeline-box timeline-content-img">
                <div className="timeline-box-wrap">
                  <h5 className="circlecount">8</h5>
                  <div className="timeline-content">
                    <span className="timeline-content-txt">
                      To find QR code in your gallery, click on this icon
                      with the red underline to select the code. The amount
                      to be paid is saved, and it will be shown to you
                      before confirming the payment with the QR code.
                    </span>
                    <img src={Step8} alt="" className="mt-2" />
                  </div>
                </div>
              </div>
              <div className="timeline-box img-right timeline-content-img">
                <div className="timeline-box-wrap">
                  <h5 className="circlecount">9</h5>
                  <div className="timeline-content">
                    <div className="timeline-content-txt">
                      <p>
                        By selecting the option "Scan QR code" highlighted
                        with the red underline, enter your phone's gallery.
                        Select the relevant QR code.
                      </p>
                    </div>
                    <img src={Step9} alt="" className="mt-2" />
                  </div>
                </div>
              </div>
              <div className="horizontal-line"></div>
              <div className="verticle-line"></div>
              <div className="corner top"></div>
              <div className="corner bottom"></div>
            </div>
            <div className="timeline-row">
              <div className="timeline-box timeline-content-img d-none">
                <div className="timeline-box-wrap">
                  <h5 className="circlecount">10</h5>
                  <div className="timeline-content">
                    <div className="timeline-content-txt">
                      <p>
                        After scanning QR code, the amount and recipient
                        address will appear as shown in the image. Click on
                        Next at the bottom of the page to confirm.
                      </p>
                    </div>
                    <img src={Step10} alt="" className="mt-2" />
                  </div>
                </div>
              </div>
              <div className="timeline-box">
                <div className="timeline-box-wrap">
                  <h5 className="circlecount">10</h5>
                  <div className="timeline-content">
                    <div className="timeline-content-txt">
                      <p>
                        After scanning QR code, the amount and recipient
                        address will appear as shown in the image. Click on
                        Next at the bottom of the page to confirm.
                      </p>
                    </div>
                    <img src={Step10} alt="" className="mt-2" />
                  </div>
                </div>
              </div>
              <div className="timeline-box img-left timeline-content-img">
                <div className="timeline-box-wrap">
                  <h5 className="circlecount">11</h5>
                  <div className="timeline-content">
                    <div className="timeline-content-txt">
                      <p>
                        On this page, click on the confirm button to
                        complete the payment. After completing the payment,
                        enter the VPN app. If you close it completely, you
                        can log back in by entering your email and password
                        and clicking on the Login option. Please wait for
                        the system to connect you to the VPN after
                        confirming the payment, which will take
                        approximately two to five minutes.
                      </p>
                    </div>
                    <img src={Step11} alt="" className="mt-2" />
                  </div>
                </div>
              </div>
              <div className="timeline-box img-left timeline-content-img">
                <div className="timeline-box-wrap">
                  <h5 className="circlecount">12</h5>
                  <div className="timeline-content">
                    <div className="timeline-content-txt">
                      <p>
                        You can always purchase a new package from the
                        section highlighted with the red underline to
                        prevent any interruption in your VPN service before
                        your current package expires.
                      </p>
                    </div>
                    <img src={Step12} alt="" className="mt-2" />
                  </div>
                </div>
              </div>
              <div className="horizontal-line"></div>
              <div className="verticle-line"></div>
              <div className="corner top"></div>
              <div className="corner bottom"></div>
              <div className="start-point end-point">
                <h4>Continue</h4>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
